/* eslint-disable */
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { CombinedReducersType } from "@type/index";
import { CheckboxGroup, Checkbox, Body } from "@common/AggregationComponent";
import {
  handleDuplicate,
  transformBrandForGoogleAnalytics
} from "@util/common";
import { sendTrackEvent, TRACK_EVENT_SEARCH } from "@util/gtm";

enum TAG_TYPE {
  SIZE = "size",
  CATEGORY = "category"
}

const emptyListColumnCount = {
  lg: 1,
  md: 1,
  sm: 1
};
const nonEmptyListColumnCount = {
  lg: 2,
  md: 2,
  sm: 2
};

interface SelectedTagsType {
  filterSizes: any[];
  filtercategories: any[];
}

const ProductTabSizeFilter = (props: any) => {
  const {
    sizes,
    selectedSizes,
    filteredSizes,
    selectedCategories,
    setIsClickSizeCheckList,
    onChangeSelectedSizes,
    setFilteredSizes
  } = props;

  const { t } = useTranslation();

  const config = useSelector((state: CombinedReducersType) => state.app);

  const isEmptyList = !filteredSizes.filter((s: any) => s.display?.showFlag)
    .length;

  const selectedTags = useMemo(
    (): SelectedTagsType => ({
      filterSizes: handleDuplicate(
        selectedSizes
          .map((size: any) => ({ ...size, type: TAG_TYPE.SIZE }))
          .sort(
            (sizeA: any, sizeB: any) => sizeA.displayCode - sizeB.displayCode
          ),
        "name"
      ),
      filtercategories: selectedCategories
        .map((size: any) => ({ ...size, type: TAG_TYPE.CATEGORY }))
        .sort((sizeA: any, sizeB: any) => sizeA.id - sizeB.id)
    }),
    [selectedSizes, selectedCategories, sizes.length]
  );

  const handlerSizeClick = (size: any) => {
    setIsClickSizeCheckList(true);
    let gaSizeArr: any = selectedTags.filterSizes.map((item) => item.name);
    const index = selectedSizes.findIndex(
      (selectedSize: any) => selectedSize.code === size.code
    );
    if (index === -1) {
      gaSizeArr.push(size.name);
      // 选择的tag 添加一个size tag
      onChangeSelectedSizes([...selectedSizes, size]);
      const sizeIndex = filteredSizes.findIndex(
        (filteredSize: any) => filteredSize.code === size.code
      );
      // 勾选size
      if (sizeIndex > -1) {
        const newSizes = filteredSizes;
        newSizes[sizeIndex].checked = true;
        setFilteredSizes([...newSizes]);
      }
    } else {
      // 点击取消 删除选择的size tag
      const newSizes = selectedSizes;
      newSizes.splice(index, 1);
      gaSizeArr = newSizes.map((item: any) => item.name);
      onChangeSelectedSizes([...newSizes]);
      const sizeIndex = filteredSizes.findIndex(
        (filteredSize: any) => filteredSize.code === size.code
      );
      // 点击取消 取消size勾选状态
      if (sizeIndex > -1) {
        const newFilteredSizes = filteredSizes;
        newFilteredSizes[sizeIndex].checked = false;
        setFilteredSizes([...newFilteredSizes]);
      }
    }
    const sizesForGa = gaSizeArr.join(",");
    const catAndGenArr = selectedTags.filtercategories.map((item) => item.name);
    const genderForGa = catAndGenArr[0] || null;
    const categoryForGa = catAndGenArr.slice(1).join(",") || null;
    sendTrackEvent({
      brand: transformBrandForGoogleAnalytics(config.brand_name),
      event: TRACK_EVENT_SEARCH,
      eventAction: "ImageItemSearch",
      eventCategory: "IS_Item_Filter",
      eventLabel: `${[...catAndGenArr, ...gaSizeArr].join(",")}`,
      genderFilter: genderForGa,
      categoryFilter: categoryForGa,
      sizeFilter: sizesForGa
    });
  };

  return (
    <>
      <div>
        {filteredSizes.length > 0 ? (
          <CheckboxGroup
            error=""
            hint=""
            id="Checkbox-color-17"
            required={false}
            columnCount={
              isEmptyList ? emptyListColumnCount : nonEmptyListColumnCount
            }
            legend={t("text_size")}
          >
            {filteredSizes.map((size: any) => {
              return (
                <Checkbox
                  checked={!!size.checked}
                  id={`${size.code}-SizeFilter`}
                  key={`${size.code}-SizeFilter`}
                  label={size.name}
                  name={size.name}
                  onChange={() => {
                    handlerSizeClick(size);
                  }}
                  value={size.code}
                />
              );
            })}
          </CheckboxGroup>
        ) : (
          <CheckboxGroup legend={t("text_size")}>
            <Body element="p" variant="standard">
              {t("text_search_filter_unavailable_size_option")}
            </Body>
          </CheckboxGroup>
        )}
      </div>
    </>
  );
};
export default ProductTabSizeFilter;
